module.exports = __webpack_public_path__ + "static/media/Whatsapp01.e0973cb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SocialMediaMenu/Whatsapp01.svg
// module id = 328
// module chunks = 0